/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 * Styled component for side bar item
 *
 * @author Yakov Gushchin
 * @author Dmitry Okunev
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const SideBarNavStyled = styled.div`
`;

export const SideBarNavItemStyled = styled.div.attrs({
    className: 'side-bar__item',
})<{ isActive: boolean }>`
    width: 100%;
    padding: 10px 8px 10px 16px;
    border-left: 2px solid ${props => props.isActive ? colors.borderColorSuccess : colors.backgroundColorModal};
    box-sizing: border-box;
    background: ${colors.backgroundColorModal};
    cursor: pointer;
    ${props => props.isActive ? fonts.textMainBold : fonts.textMain};
    &:last-child {
        border-bottom: none;
    }
    &:hover {
        background: ${colors.backgroundColorHoverNormal};
    }
`;
